import { Component, Input, inject } from '@angular/core';
import { Address, ToasterService } from '@lc/core';
import { MatListItem } from '@angular/material/list';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { ClipboardModule } from 'ngx-clipboard';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'lc-address-menu-item',
  templateUrl: './address-menu-item.component.html',
  styleUrls: ['./address-menu-item.component.scss'],
  imports: [
    MatListItem,
    NgClass,
    MatIcon,
    MatTooltip,
    MatIconButton,
    ClipboardModule,
    RouterLink,
  ],
})
export class AddressMenuItemComponent {
  private toasterService = inject(ToasterService);

  @Input() address: Address;
  @Input() showClipboard: boolean;
  @Input() isExpanded: boolean = true;
  @Input() hideIcon: boolean = false;
  @Input() editLink: string | any[];
  @Input() replaceUrl: boolean;

  /**
   * Returns a toaster to the UI on copy to clipboard.
   */
  copied(event) {
    if (event.isSuccess) {
      this.toasterService.showInfo('Address copied to board!');
    } else {
      this.toasterService.showError('Failed to copy the address');
    }
  }
}
